import type { TourStep } from "./HostTourOverlay";

export const HOST_TOUR_STEPS: TourStep[] = [
  {
    selector: "aside.bg-brand",
    titleKey: "host_tour.step_sidebar_title",
    bodyKey: "host_tour.step_sidebar_body",
    placement: "right",
  },
  {
    selector: "[data-tour='hero']",
    titleKey: "host_tour.step_overview_title",
    bodyKey: "host_tour.step_overview_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='actions']",
    titleKey: "host_tour.step_actions_title",
    bodyKey: "host_tour.step_actions_body",
    placement: "bottom",
  },
  {
    selector: "a[href='/dashboard/bookings']",
    titleKey: "host_tour.step_bookings_title",
    bodyKey: "host_tour.step_bookings_body",
    placement: "right",
  },
  {
    selector: "a[href='/dashboard/earnings']",
    titleKey: "host_tour.step_earnings_title",
    bodyKey: "host_tour.step_earnings_body",
    placement: "right",
  },
  {
    selector: "a[href='/dashboard/listings']",
    titleKey: "host_tour.step_vehicles_title",
    bodyKey: "host_tour.step_vehicles_body",
    placement: "right",
  },
];

// Task #4221 — Earnings page tour. Each step's selector points at a real
// section on EarningsPage; HostTourOverlay auto-skips any step whose anchor is
// absent (e.g. the Stripe Connect status card only renders for Connect hosts,
// the export buttons only render when there are transactions), so the spotlight
// never lands on a missing element.
export const EARNINGS_TOUR_STEPS: TourStep[] = [
  {
    selector: "[data-tour='earnings-stats']",
    titleKey: "earnings_tour.step_glance_title",
    bodyKey: "earnings_tour.step_glance_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='earnings-payouts']",
    titleKey: "earnings_tour.step_payouts_title",
    bodyKey: "earnings_tour.step_payouts_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='earnings-missed']",
    titleKey: "earnings_tour.step_missed_title",
    bodyKey: "earnings_tour.step_missed_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='earnings-transactions']",
    titleKey: "earnings_tour.step_transactions_title",
    bodyKey: "earnings_tour.step_transactions_body",
    placement: "top",
  },
  {
    selector: "[data-tour='earnings-export']",
    titleKey: "earnings_tour.step_export_title",
    bodyKey: "earnings_tour.step_export_body",
    placement: "bottom",
  },
];

// Task #4221 — Reviews page tour. Doubles as the first surfacing of the
// existing host-reviews-guest capability (spotlight only — no review logic is
// added here). The "review your guests" + double-blind steps point at the
// Pending tab and a small static fairness explainer respectively.
export const REVIEWS_TOUR_STEPS: TourStep[] = [
  {
    selector: "[data-tour='reviews-why']",
    titleKey: "reviews_tour.step_why_title",
    bodyKey: "reviews_tour.step_why_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='reviews-tab-pending']",
    titleKey: "reviews_tour.step_review_guests_title",
    bodyKey: "reviews_tour.step_review_guests_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='reviews-fair']",
    titleKey: "reviews_tour.step_fair_title",
    bodyKey: "reviews_tour.step_fair_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='reviews-tab-about_me']",
    titleKey: "reviews_tour.step_about_me_title",
    bodyKey: "reviews_tour.step_about_me_body",
    placement: "bottom",
  },
  {
    selector: "[data-tour='reviews-tab-written']",
    titleKey: "reviews_tour.step_i_wrote_title",
    bodyKey: "reviews_tour.step_i_wrote_body",
    placement: "bottom",
  },
];

